/** Three container:
 * <div> below is the container of the canvas
 * holding threejs scene
 * 
 * @ref attribute gets a reference to the div element
 * @threeEntryPoint() is called when the function componentDidMount() 
 * is automatically called by React, when the component is mounted.
 */

import React from 'react';
import SceneController from './SceneController';

export default class Home extends React.Component
{
    constructor()
    {
        super();
        this.sceneController = new SceneController();
    };

    componentDidMount() 
    {
        this.addEventListeners();
        this.sceneController.setup();
        this.update();
    };

    componentWillUnmount() 
    {
        window.removeEventListener('resize', this.onWindowResize);
        document.removeEventListener("mousedown", this.onDocumentMouseDown);
        document.removeEventListener("mouseup", this.onDocumentMouseUp);
        document.removeEventListener("mousemove", this.onDocumentMouseMove);
        document.removeEventListener("keydown", this.onDocumentKeyDown);
        document.removeEventListener("keyup", this.onDocumentKeyUp);
        if (this.sceneController) this.sceneController.dispose();
    };

    addEventListeners()
    {
        window.addEventListener('resize', this.onWindowResize, false);
        document.addEventListener("mousedown", this.onDocumentMouseDown, false);
        document.addEventListener("mouseup", this.onDocumentMouseUp, false);
        document.addEventListener("mousemove", this.onDocumentMouseMove, false);
        document.addEventListener("keydown", this.onDocumentKeyDown, false);
        document.addEventListener("keyup", this.onDocumentKeyUp, false);
    };

    onWindowResize = () => 
    {
        if(this.sceneController) 
        {
            this.sceneController.onWindowResize();
            this.sceneController.update();
        }    
    };

    onDocumentMouseDown = (e) =>
    {
        e.preventDefault();
        if(this.sceneController) this.sceneController.onMouseDown(e);
    };

    onDocumentMouseUp = (e) =>
    {
        e.preventDefault();
        if(this.sceneController) this.sceneController.onMouseUp(e);
    };

    onDocumentMouseMove = (e) =>
    {
        e.preventDefault();
        if(this.sceneController) this.sceneController.onMouseMove(e);
    };

    onDocumentKeyDown = (e) =>
    {
        e.preventDefault();
        switch (e.keyCode) 
        {
            case 67: // c
                // this.showInstructions();
                this.sceneController.setupMainScene();
                break;

            case 27: // esc
                console.log('esc is pressed');
                // this.sceneController.dispose();
                break;

            case 32: // space
                // console.log('space is pressed');
                break;
            default:        
        }    
        if(this.sceneController) this.sceneController.onKeyDown(e);
    };

    onDocumentKeyUp = (e) =>
    {
        e.preventDefault();
        if(this.sceneController) this.sceneController.onKeyUp(e);
    };

    showInstructions()
    {
        let instructions = document.getElementById("instructions");
        instructions.innerHTML= `
            <span style="font-size:36px">Click to enter</span>
            <br /><br />
            Move: WASD<br/>
            Look: MOUSE
            `;   
        // return(
        //     <Instructions />
        // );
        
    };

    update = () =>
    {
        requestAnimationFrame(this.update);
        if(this.sceneController) this.sceneController.update();
    };

    render()
    {    return(
            <div>
                <div ref={element => this.threeRootElement = element} />
                <div id="blocker" className="blocker">
                        <div id="instructions" className="instructions">
                        </div>
                    </div>
                    <svg className="pointer_wrapper" expanded="true" height="50px" width="50px">
                        <circle cx="50%" cy="50%" r="2%" stroke="#fff" strokeWidth="6%" fill="none">
                        <animate id="pointerGrow" attributeName="r" begin="indefinite" dur=".15s" repeatCount="1" from="2%" to="15%" fill="freeze"/>
                        <animate id="pointerShrink" attributeName="r" begin="indefinite" dur=".15s" repeatCount="1" from="15%" to="2%" fill="freeze"/>
                    </circle>
                </svg>
            </div>
        );
    }
};

// const Instructions = () =>
// {
//     return(
//         <div style={{
//             // backgroundColor: '#2F3E4F',
//         }}>
//             Click to enter
//             <br /><br />
//             Move: WASD<br/>
//             Look: MOUSE
//             `;   
//         </div>
//     );
// };
